import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../pt/pt-flow-new/CommonStatCard";
import {
  getCardLabel,
  getCardValue,
} from "../common-data/Conversions";

const RefferalStat = () => {
  const { referralStatLoading, referralStatError, referralStat } = useSelector(
    (state) => state.prospects
  );

  const iniDatas = {
    allStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const EXCLUDED_KEYS = ["total_converted_value"];

  const STAT_ORDER = [
    "total",
    "total_pending",
    "total_converted",
    "total_not_converted",
    "total_added_to_lead",
    "total_not_added_to_lead",
  ];

  const sortedCards =
    allDatas.allStats &&
    Object?.entries(allDatas.allStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key, false, "referral")}
              value={getCardValue(
                key,
                value || 0,
                allDatas.allStats?.total_converted_value
              )}
            />
          )}
        </React.Fragment>
      ));

  useEffect(() => {
    if (
      !referralStatLoading &&
      !referralStatError &&
      referralStat?.status &&
      referralStat?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allStats: referralStat.data?.[0] || {},
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [referralStatLoading, referralStatError, referralStat]);

  return (
    <div className="cards-container cards-grid-container grid-5 pt-flow-new">
      {sortedCards}
    </div>
  );
};

export default RefferalStat;
